import { HttpService } from "../../modules/shared/services/http.service";
import { Credit, CreditCreateDto, CreditBalance, CreditsResponse, CreditFilters, CreditSort } from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

export const createCredit = async (data: CreditCreateDto): Promise<Credit> => {
	const response = await HttpService.post("api/v1/credits", data, headers, true);
	return response;
};

export const updateCredit = async (id: string, data: Partial<CreditCreateDto>): Promise<Credit> => {
	const response = await HttpService.patch(`api/v1/credits/${id}`, data, headers, true);
	return response;
};

export const getCreditById = async (id: string): Promise<Credit> => {
	const response = await HttpService.get(`api/v1/credits/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getCredits = async (query?: Record<string, string | number | boolean>): Promise<CreditsResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/credits${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteCredit = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/credits/${id}`, { "x-custom-lang": "en" }, true);
};

export const getUserCredits = async (userId: string, query?: Record<string, string | number | boolean>): Promise<CreditsResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/credits/user/${userId}${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getUserCreditBalance = async (userId: string): Promise<CreditBalance> => {
	const response = await HttpService.get(`api/v1/credits/user/${userId}/balance`, true, { "x-custom-lang": "en" });
	return response;
};

export const getCreditsWithFilters = async (filters?: CreditFilters, sort?: CreditSort[], page?: number, limit?: number): Promise<CreditsResponse> => {
	const query: Record<string, string | number | boolean> = {};
	
	if (filters) {
		if (filters.userId) query.userId = filters.userId;
		if (filters.statusId) query.statusId = filters.statusId;
		if (filters.subscriptionPlanId) query.subscriptionPlanId = filters.subscriptionPlanId;
		if (filters.escrowId) query.escrowId = filters.escrowId;
	}
	
	if (sort && sort.length > 0) {
		query.sort = JSON.stringify(sort);
	}
	
	if (page) query.page = page;
	if (limit) query.limit = limit;
	
	return getCredits(query);
};

export const getUserCreditsWithFilters = async (userId: string, filters?: CreditFilters, sort?: CreditSort[], page?: number, limit?: number): Promise<CreditsResponse> => {
	const query: Record<string, string | number | boolean> = {};
	
	if (filters) {
		if (filters.statusId) query.statusId = filters.statusId;
		if (filters.subscriptionPlanId) query.subscriptionPlanId = filters.subscriptionPlanId;
		if (filters.escrowId) query.escrowId = filters.escrowId;
	}
	
	if (sort && sort.length > 0) {
		query.sort = JSON.stringify(sort);
	}
	
	if (page) query.page = page;
	if (limit) query.limit = limit;
	
	return getUserCredits(userId, query);
};
